import {fetchIndicatorDataForArea} from './fetchIndicatorData.js';
import {fetchIndicatorQuantiles, fetchIndicatorLabels} from './fetchIndicatorData.js';
import shapeStyles from './shapeStyles.js';
//const indicator_quartile_data = require('./1458_q_test.json');
// Mapbox GL is loaded from script tags before the app loads
var mapboxgl = window.mapboxgl;

/*
Bivariate map palette
1 = #424B54
2 = #1C747E
3 = #00939D
4 = #AA5D43
5 = #B19D6E
6 = #8BB587
7 = #FF6B35
8 = #FF9D54
9 = #FFD275

Demo ID card 24647 - indicators 4364/4360
Qm9hcmRDYXJkVXNlTm9kZToyNDY0Nw==
*/
/*
var my_data_projection = "EPSG:4326";
var my_feature_projection = "EPSG:3857";
var colors_def_test = [
    "rgba(211, 211, 211, 0.4)",
    "rgba(120, 162, 47, 0.4)",
    "rgba(106, 141, 115, 0.4)",
    "rgba(213, 222, 214, 0.4)",
    "rgba(255, 169, 135, 0.4)",
    "rgba(255, 107, 53, 0.4)",
    ];
var colors_def_transparent = [
    "gray",
    "green",
    "yellow",
    "orange",
    "red",
    "blue",
    "rgba(255, 255, 255, 0.0)",
    ];
*/

export function findLayerByIndicatorId(indicatorId) {
  const bivariate = indicatorId.length === 2;
  for(let i = 0; i < this.mapIndicatorLayers.length; i++) {
      // TODO: search global crosswalk array for layer with indicatorId
    if (bivariate) {
        if (this.mapIndicatorLayers[i]['indicatorId'][0] === indicatorId[0] && 
            this.mapIndicatorLayers[i]['indicatorId'][1] === indicatorId[1]) {
          return this.mapIndicatorLayers[i].layerId;
        }
    }
    else if (this.mapIndicatorLayers[i]['indicatorId'] === indicatorId) {
      return this.mapIndicatorLayers[i].layerId;
    }
  }
  return null;
}

export function findLayerConfigByIndicatorId(indicatorId) {
  for(let i = 0; i < this.mapIndicatorLayers.length; i++) {
      // TODO: search global crosswalk array for layer with indicatorId
    if (this.mapIndicatorLayers[i]['indicatorId'] === indicatorId) {
      return this.mapIndicatorLayers[i];
    }
  }
  return null;
}

export function handleMapMoved(e) {
    /*
  //console.log("Map moveend event callback");
  let view = this.map.getView();
  let extent = view.calculateExtent(this.map.getSize());
  let northwest = proj.toLonLat([extent[0], extent[3]]);
  let southeast = proj.toLonLat([extent[2], extent[1]]);
  //console.log(proj.toLonLat(northwest));
  //console.log(proj.toLonLat(southeast));
  this.setState({northwest, southeast });
  */
  return true;
}

export function getMapCenterAndZoom() {
  let centerLonLat = this.map.getCenter().toArray();
  let zoom = Math.round(this.map.getZoom());
  return {centerLonLat, zoom};
}

export function getMapPdf() {
  // TODO: build PDF file with map image and text below
  console.log("getMapPdf");
}

export function getMapPngUrl() {
    //let canvas = window.document.getElementsByTagName("canvas")[0];
    let canvas = this.map.getCanvas();
    return canvas.toDataURL();
}

export function resizeMap() {
    if (this.map && this.state.mapInitialized) {
        setTimeout(() => {
            this.map.resize();
        }, 0);
    }
}

export function getMapPng() {

  console.log("getMapPng");
  /*
  //TODO: this would have to be done and then reversed after png export
  // to force a higher-resolution image output than the screen
  this.map.once('precompose', function(event) {
      let canvas = window.document.getElementsByTagName("canvas")[0];
      setDPI(canvas, 300);
  });
  */
  this.map.once('rendercomplete', function(event) {
    console.log("map rendered, starting png build");
    // TODO: set map export filename here (maybe map_yyyymmddhhmmss.png)
    const mapFileName = 'map.png';
    var canvas = event.context.canvas;
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(canvas.msToBlob(), mapFileName);
    } else {
      canvas.toBlob(function(blob) {
        window.saveAs(blob, mapFileName);
      });
    }
  });
  this.map.renderSync();
}

export function handleMapLayerGeographyChanged(oldIndicatorId, newIndicatorId,
    newSummaryLevelCode) {
    for(var i = 0; i < this.mapIndicatorLayers.length; i++) {
        if(this.mapIndicatorLayers[i].indicatorId === oldIndicatorId) {
            this.mapIndicatorLayers[i].indicatorId = newIndicatorId;
            let oldLayerId = this.mapIndicatorLayers[i].layerId;
            this.mapIndicatorLayers[i].layerId = newIndicatorId;
            this.updateMapLayer(
                {"indicatorId": newIndicatorId,
                 "summaryLevelCode": newSummaryLevelCode,
                 "visible": true,
                 "index": this.mapIndicatorLayers[i].paletteIndex,
                 "customPalette": this.mapIndicatorLayers[i].customPalette},
                true, oldLayerId, true);
            this.map.removeLayer(oldLayerId);
            break;
        }
    }
}

export function handleMapLayerOpacityChanged(indicatorId, opacity) {
  let updatedLayer = this.findLayerByIndicatorId(indicatorId);
  console.log("this.mapIndicatorLayers", this.mapIndicatorLayers);
  console.log("handleMapLayerOpacityChanged indicatorId", indicatorId);
  console.log("handleMapLayerOpacityChanged updatedLayer", indicatorId);
  if(updatedLayer != null) {
    this.map.setPaintProperty(updatedLayer, 'fill-opacity', opacity);
  }
}

export function handleMapLayerPaletteChanged(indicatorId, palette) {
  let updatedLayerConfig = this.findLayerConfigByIndicatorId(indicatorId);
  if(updatedLayerConfig != null) {
      updatedLayerConfig['paletteIndex'] = palette;
      updatedLayerConfig['customPalette'] = shapeStyles[palette];
      // swapping color palette requires resetting paint rules for layer
      this.refreshMapLayerSource(updatedLayerConfig['indicatorId'], this.state.filterByArea);
  }
}

export function handleMapLayerPositionChanged(indicatorId, index) {
    /*
  let currentLayers = this.map.getLayers();
  let updatedLayer = this.findLayerByIndicatorId(indicatorId);
  if(updatedLayer != null) {
    updatedLayer.setZIndex(98 - index);
    updatedLayer.set("position", index);
    updatedLayer.setStyle(styleFunction.bind(this, indicatorId,
        index%6));
    //console.log("moved layer to position", index);
  }
    */
}

export function handleMapLayerRemoved(indicatorId) {
  // rebind other indicator layers based on new array index?
  console.log("handleMapLayerRemoved");
  for(let i = 0; i < this.mapIndicatorLayers.length; i++) {
    if (this.mapIndicatorLayers[i]['indicatorId'] === indicatorId) {
      let removedLayer = this.mapIndicatorLayers[i]['layerId'];
      this.map.removeLayer(removedLayer);
      this.mapIndicatorLayers.splice(i, 1);
      this.updateAreaHighlightVisibility();
      return removedLayer;
    }
  }
  return null;
}

export function handleMapLayerOutlinesVisibilityChanged(summaryLevelCode, visibility)
{
    var layerId = 'countiesoutlines';
    if(summaryLevelCode == '050') {
        layerId = 'countiesoutlines';
    }
    this.map.setLayoutProperty(layerId, 'visibility', (visibility === true) ? 'visible' : 'none');
}

export function handleMapLayerVisibilityChanged(indicatorId, visibility) {
  let updatedLayerConfig = this.findLayerConfigByIndicatorId(indicatorId);
  if(updatedLayerConfig != null) {
    updatedLayerConfig['visible'] = visibility;
    this.map.setLayoutProperty(updatedLayerConfig.layerId, 'visibility',
        (visibility === true) ? 'visible' : 'none');
    this.updateAreaHighlightVisibility();
  }
}

export function updateAreaHighlightVisibility() {
    if(this.mapIndicatorLayers.length > 0) {
        for(var i = 0; i < this.mapIndicatorLayers.length; i++) {
            // No highlights for area when visible indicators are selected
            //console.log("updateAreaHighlightVisibility", this.mapIndicatorLayers[i]);
            if(this.mapIndicatorLayers[i].visible === true) {
                this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
                this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
                this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
                return;
            }
        }
    }
    // Enable highlights for area when no visible indicators selected
    //console.log("updateAreaHighlightVisibility", this.typeOfArea);
    if(this.typeOfArea === 'ZIPLIST') {
        this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
        this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
        this.map.setLayoutProperty('selectedzcta', 'visibility', 'visible');
    } else if(this.typeOfArea === 'PLACELIST') {
        this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
        this.map.setLayoutProperty('selectedplaces', 'visibility', 'visible');
        this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
    } else {
        this.map.setLayoutProperty('selectedcounties', 'visibility', 'visible');
        this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
        this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
    }
}

export function handleMapRenderComplete(e) {
  console.log("handleMapRenderComplete");
  if(!this.state.mapInitialized) {
    this.setState({ mapInitialized: true }, (state) => { this.setupBaseMapLayers() });
  }
}

// retrieve data for indicator and refresh map layer when done
// TODO: update all references to this function for new argument list,
//   call only when loading data not filtered by area
export async function loadIndicatorData(indicatorId) {
  if(this.indicatorData[indicatorId] == null)
  {
    this.indicatorData[indicatorId] = 1;
    this.indicatorData[indicatorId] =
      await fetchIndicatorQuantiles(indicatorId);
    //console.log(this.indicatorData[indicatorId][data_quadrant]);
    this.refreshMapLayerSource(indicatorId, false);
    this.indicatorLabels[indicatorId] = 1;
    this.indicatorLabels[indicatorId] = 
      await fetchIndicatorLabels(indicatorId);
    return true;
  }
  // data was previously requested,
  //   refresh paint rules in case we switched filters
  this.refreshMapLayerSource(indicatorId, false);
  return false;
}

// retrieve data for indicator and refresh map layer when done
// TODO: call when loading data filtered by area
export async function loadIndicatorDataForArea(indicatorId, savedAreaId) {
  // TODO: set up this alternative destination array for area-filtered data
  if(savedAreaId == null) {
      console.log("No area selected");
      return false;
  }
  if(this.indicatorDataForArea[indicatorId] == null)
  {
    this.indicatorDataForArea[indicatorId] = null;
  }
  if(this.indicatorDataForArea[indicatorId] !== 1)
  {
    this.indicatorDataForArea[indicatorId] = 1;
    this.indicatorDataForArea[indicatorId] =
      await fetchIndicatorDataForArea(indicatorId, savedAreaId);
    //console.log(this.indicatorDataForArea[indicatorId][data_quadrant]);
    // TODO: update this function to branch on new parameter filterByArea
    if(this.state.filterByArea === true) {
        this.refreshMapLayerSource(indicatorId, true);
    } else {
        console.log("skipping layer refresh filterByArea is ", this.state.filterByArea);
    }
    return true;
  }
  // data was previously requested
  return false;
}

// TODO: reload all current indicator layers to reflect new selected area filter
export async function updateSavedArea(savedAreaId) {
    this.mapSavedAreaId = savedAreaId;
    // Start reload of each indicator for new area
    for (var i = 0; i < this.mapIndicatorLayers.length; i++) {
        console.log("updateSavedArea reloading layer", i, this.mapIndicatorLayers[i].indicatorId);
        if(this.mapIndicatorLayers[i].indicatorId != null &&
           this.mapIndicatorLayers[i].indicatorId !== "") {
            this.loadIndicatorDataForArea(this.mapIndicatorLayers[i].indicatorId, savedAreaId);
        }
    }
    // TODO: zoom to selected area when selecting a new saved area
}

// TODO: transition between filtering indicator layers by selected area or
//   showing all available US geography
export async function setFilterByArea(setFilterByArea) {
    if(setFilterByArea === true) {
        // TODO: this could be optimized to not reload data for same area
        //    (but browser caching means it doesn't really reload anyway)
        // Start reload of each indicator for selected saved area
        for (var i = 0; i < this.mapIndicatorLayers.length; i++) {
            if(this.mapIndicatorLayers[i].indicatorId != null &&
               this.mapIndicatorLayers[i].indicatorId !== "") {
                this.loadIndicatorDataForArea(this.mapIndicatorLayers[i].indicatorId, this.mapSavedAreaId);
            }
        }
    } else {
        // Start load of each indicator for all of US (if not already loaded)
        for (let i = 0; i < this.mapIndicatorLayers.length; i++) {
            if(this.mapIndicatorLayers[i].indicatorId != null &&
               this.mapIndicatorLayers[i].indicatorId !== "") {
                this.loadIndicatorData(this.mapIndicatorLayers[i].indicatorId);
            }
        }
    }
}

// assign Z-Index to base map layers after they load from MapTiler
// force refresh of rendered shapes for map layer after data loaded
export function refreshMapLayerSource(indicatorId, filterByArea) {
    let mapLayerConfig = this.findLayerConfigByIndicatorId(indicatorId);
    let mapLayer = mapLayerConfig ? mapLayerConfig['layerId'] : null;
    if(mapLayer == null) {
        console.log("refreshMapLayerSource layer not found", indicatorId);
        return false;
    }
    const bivariate = mapLayer.length === 2;
    //console.log("refreshMapLayerSource layer found", indicatorId);
    var color_palette = shapeStyles[mapLayerConfig['paletteIndex']];
    if(mapLayerConfig['customPalette'] != null && mapLayerConfig['customPalette'].length > 4) {
        color_palette = mapLayerConfig['customPalette'];
    }
    if(bivariate) {
        mapLayer = mapLayer[0] + "," + mapLayer[1];
        //console.log(this.map.getLayer(mapLayer));
        color_palette = shapeStyles[6];
    }
    //console.log(mapLayerConfig);
    if(filterByArea) {
        // For area-masked dataset use an array of one list of geoids for each quartile for every shape in the area at the geographic unit level matching the selected indicator
        var indicator_quartile_data = this.indicatorDataForArea[indicatorId];
        this.map.setPaintProperty(mapLayer, 'fill-color', [
                    'match',
                    ['get', 'geo_id'],
                    indicator_quartile_data[1], color_palette[1],
                    indicator_quartile_data[2], color_palette[2],
                    indicator_quartile_data[3], color_palette[3],
                    indicator_quartile_data[4], color_palette[4],
                    color_palette[6]
                ]);
    } else {
        // For a non-area-masked (all of US) dataset use a pre-compiled array of all shapes indexed to match an index property we set in the TIGER shape list
        var listOfQuartilesForAllBG = this.indicatorData[indicatorId];
        //console.log("listOfQuartilesForAllBG", listOfQuartilesForAllBG);
        this.map.setPaintProperty(mapLayer, 'fill-color', [
            'to-color', ['at', ['at', ['get', 'ogc_fid'], ['literal', listOfQuartilesForAllBG]], ['literal', color_palette]]
        ]);
        if(bivariate) {
            // TODO: fix this not being set/controlled properly for bivariate layers in panel
            this.map.setLayoutProperty(mapLayer, 'visibility', 'visible');
            //this.map.setPaintProperty(mapLayer, 'fill-opacity', 1.0);
        }
    }
}

export function fitMapToExtent(item, latLngExt) {
  if(this.map != null && latLngExt != null) {
    this.map.fitBounds([[latLngExt[0], latLngExt[1]], [latLngExt[2], latLngExt[3]]]);
  }
}

export function flyMapToExtent(mapCenterLng, mapCenterLat, mapZoom) {
    if(this.map != null) {
        this.map.flyTo({center: [mapCenterLng, mapCenterLat], zoom: mapZoom});
    }
}

/*
export function mapPointInfo(point) {
    features = this.map.querySourceFeatures('base150vectortiles',
        {
            "sourceLayer": "base150",
            "filter": []
        });
}
*/

export function highlightSavedArea(typeOfArea, primaryGeoIdList) {
    this.typeOfArea = typeOfArea;
    if(this.map != null) {
        console.log("highlightSavedArea", typeOfArea);
        if(typeOfArea === 'ZIPLIST') {
            this.map.setPaintProperty('selectedzcta', 'fill-color', [
                'match',
                ['get', 'geo_id'],
                primaryGeoIdList, "rgba(0, 143, 170, 0.4)",
                "transparent"]
                );
            this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
            this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
            this.map.setLayoutProperty('selectedzcta', 'visibility', 'visible');
        } else if(typeOfArea === 'PLACELIST') {
            this.map.setPaintProperty('selectedplaces', 'fill-color', [
                'match',
                ['get', 'geo_id'],
                primaryGeoIdList, "rgba(0, 143, 170, 0.4)",
                "transparent"]
                );
            this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
            this.map.setLayoutProperty('selectedplaces', 'visibility', 'visible');
            this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
        } else {
            this.map.setPaintProperty('selectedcounties', 'fill-color', [
                'match',
                ['get', 'geo_id'],
                primaryGeoIdList, "rgba(0, 143, 170, 0.4)",
                "transparent"]
                );
            this.map.setLayoutProperty('selectedcounties', 'visibility', 'visible');
            this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
            this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
        }
        // No highlights for area when visible indicators are selected
        if(this.mapIndicatorLayers.length > 0) {
            for(var i = 0; i < this.mapIndicatorLayers.length; i++) {
                if(this.mapIndicatorLayers[i].visible === true) {
                    this.map.setLayoutProperty('selectedcounties', 'visibility', 'none');
                    this.map.setLayoutProperty('selectedplaces', 'visibility', 'none');
                    this.map.setLayoutProperty('selectedzcta', 'visibility', 'none');
                    return;
                }
            }
        }
    }
}

export function moveAndZoomMap(mapZoom, mapCenterLng, mapCenterLat) {
  if(this.map != null) {
    this.map.flyTo({zoom: mapZoom}, {center: [mapCenterLng, mapCenterLat]});
  }
}

/* TODO: save map state (if logging in/switching user accounts) and remove map */
export function removeMap(mapZoom, mapCenterLng, mapCenterLat, mapBaseStyle) {
    if(this.map != null) {
        try {
            this.map.remove();
            this.map = null;
        } catch(x) {
            console.error("failed to remove map");
        }
    }
}

/* IMPORTANT: this function initializes the Mapbox GL map and connects it to the DOM */
export function renderMap(mapZoom, mapCenterLng, mapCenterLat, mapBaseStyle, callback=null, countiesoutlines=false, is_embedded_map=false) {
  if(this.map != null) {
    //this.updateMapLayer(this.testIndicator);
    console.log("Mapbox GL map already initialized");
    //this.map.setTarget(window.document.getElementById('map'));
    return;
  }
  console.log("initializing Mapbox GL map");
  console.log(mapZoom, mapCenterLng, mapCenterLat);
  // assign map base tiles using MapTiler MapBox style file
  var styleUrl;
  if(mapBaseStyle === "hybrid") {
      styleUrl = 'https://api.maptiler.com/maps/hybrid/style.json?key=92mrAH6NBXO3jvPRMmT9';
  }
  else if (mapBaseStyle === "darkmatter") {
      styleUrl = 'https://api.maptiler.com/maps/darkmatter/style.json?key=92mrAH6NBXO3jvPRMmT9';
  } else {
      //styleUrl = 'https://api.maptiler.com/maps/positron/style.json?key=92mrAH6NBXO3jvPRMmT9'
      //styleUrl = 'https://api.maptiler.com/maps/02570677-f35a-4731-8ca7-25009ca7454e/style.json?key=92mrAH6NBXO3jvPRMmT9';
      styleUrl = 'https://api.maptiler.com/maps/32ee6c52-91ce-49e7-8fb0-84840584a1b7/style.json?key=92mrAH6NBXO3jvPRMmT9';
  }
  console.log("styleUrl", styleUrl);
  console.log("mapBaseStyle", mapBaseStyle);
  this.mapIndicatorLayers = [];
  //[{"indicatorId": "U2VhcmNoYWJsZUluZGljYXRvck5vZGU6MTQ1OA==", "layerId": "indicatorLayer1", "zIndex": 0}];
  this.map = new mapboxgl.Map({
        container: 'map',
          style: styleUrl,
          center: [-98.585522, 39.8333333],
          zoom: 2,
          preserveDrawingBuffer: true,
          minZoom: 2,
          maxZoom: 20,
    });
    
    // Create a popup, but don't add it to the map yet.
    this.popup = new mapboxgl.Popup({
        closeButton: true
    });
    
    this.map.addControl(new mapboxgl.NavigationControl());
    //this.map.setStyle('https://maps.tilehosting.com/styles/hybrid/style.json?key=92mrAH6NBXO3jvPRMmT9');
    this.map.on("load", async () => {

        // TODO: get the bottom symbol layer from base map so we can draw our shapes under all text labels
        // NOTE: Mapbox GL layers are each painted on top of the previous layers, so the first one in the list is the bottom layer of paint
        var layers = this.map.getStyle().layers;
        // Find the index of the first symbol layer in the map style
        this.firstSymbolId = null;
        for (var i = 0; i < layers.length; i++) {
            if (layers[i].type === 'symbol') {
                this.firstSymbolId = layers[i].id;
                break;
            }
        }
        
        this.map.addSource("base150vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/150/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 10
        });
        this.map.addSource("base140vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/140/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 10
        });
        this.map.addSource("base860vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/860/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 10
        });
        this.map.addSource("base160vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/160/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 10
        });
        this.map.addSource("base050vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/050/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 8
        });
        this.map.addSource("base040vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/040/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 7
        });
        this.map.addSource("base010vectortiles", {
                "type": "vector",
                "tiles": [
                    "https://www.broadstreet.io/bsdata/basetiles/010/{z}/{x}/{y}.pbf",
                ],
                "maxzoom": 6
        });
                            /*
                    "1500000US080770018001", "blue",
                    "1500000US201639747001", "green",*/
/*
        this.map.addLayer({
            "id": "problemshapes",
            "type": "fill",
            "source": "base150vectortiles",
            "source-layer": "base150",
            "paint": {
                'fill-color': [
                    'match',
                    ['get', 'geo_id'],
                    ["1500000US080459519011", "1500000US490532701003"], "red",
                    "transparent"
                ]
        }});

        this.map.on('click', 'problemshapes', function (e) {
            var coordinates = e.features[0].geometry.coordinates[0][0].slice();
            var description = e.features[0].properties.geo_id;

            console.log("Click on: ", coordinates, description);
            console.log(e.features[0].geometry);
            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
        });
        */
        this.map.addLayer({
            'id': 'counties-highlighted',
            'type': 'fill',
            'source': 'base050vectortiles',
            'source-layer': 'base050',
            'paint': {
                'fill-outline-color': '#484896',
                'fill-color': '#6e599f',
                'fill-opacity': 0.75
            },
            'filter': ['==', 'ogc_fid', '']
        }, this.firstSymbolId);
        this.map.addLayer({
            "id": "countiesoutlines",
            "type": "line",
            "source": "base050vectortiles",
            "source-layer": "base050",
            "paint": {
                'line-color': '#403F4C',
                'line-width': 0.5
            },
            "layout": {
                'line-join': 'round',
                'line-cap': 'round',
                'visibility': countiesoutlines === true ? 'visible' : 'none'
            }
        }, 'counties-highlighted');
        this.firstSymbolId = "countiesoutlines";
        this.map.addLayer({
            "id": "selectedcounties",
            "type": "fill",
            "source": "base050vectortiles",
            "source-layer": "base050",
            "paint": {
                'fill-color': [
                    'match',
                    ['get', 'geo_id'],
                    ["0"], "rgba(0, 143, 170, 0.4)",
                    "transparent"
                ]
            },
            "layout": {
                "visibility": "none"
            }
        }, this.firstSymbolId);
        this.map.addLayer({
            "id": "selectedplaces",
            "type": "fill",
            "source": "base160vectortiles",
            "source-layer": "base160",
            "paint": {
                'fill-color': [
                    'match',
                    ['get', 'geo_id'],
                    ["0"], "rgba(0, 143, 170, 0.4)",
                    "transparent"
                ]
            },
            "layout": {
                "visibility": "none"
            }
        }, this.firstSymbolId);
        this.map.addLayer({
            "id": "selectedzcta",
            "type": "fill",
            "source": "base860vectortiles",
            "source-layer": "base860",
            "paint": {
                'fill-color': [
                    'match',
                    ['get', 'geo_id'],
                    ["0"], "rgba(0, 143, 170, 0.4)",
                    "transparent"
                ]
            },
            "layout": {
                "visibility": "none"
            }
        }, this.firstSymbolId);
        
                /*
                "type": "geojson",
                "data": "./cb_2017_all_bg_500k.json",
                "data": {
                    "type": "FeatureCollection",
                    "features": []
                },

                /* NOTE: Setting tolerance too high discards small complex shapes completely
                "tolerance": 0.05,
                */
        // TODO: some CBG shapes are not simplifying correctly at some zoom levels
        // TODO: layer position name needs to vary with map base style/tileset
        // TODO: map indicator layers and sources must be readded when changing map base style
        //this.map.setStyle('https://maps.tilehosting.com/styles/hybrid/style.json?key=92mrAH6NBXO3jvPRMmT9');

        //console.log('blockgroups cc-indicatorId: ', this.map.getLayer('blockgroups').ccIndicatorId, this.map.getLayer('blockgroups').ccZIndex);
        this.handleMapRenderComplete();
        if(callback != null) {
            callback();
        }
        if(this.mapSavedAreaId != null) {
            this.zoomMapAndHighlightArea(this.mapSavedAreaId, false);
        } else if(mapCenterLng != null && mapZoom != null) {
            this.map.flyTo({center: [mapCenterLng, mapCenterLat], zoom: mapZoom});
        }
    });
}

export function setupBaseMapLayers() {
  // base map layers are set so safe to link preloaded indicators now
  if(this.mapSavedAreaId != null) {
    this.setState({filterByArea: true}, this.loadPreloadedIndicatorLayers);
    // TODO: suppress if layers exist to load?
    if(this.state.oneTimeMapZoomToArea) {
        this.zoomMapAndHighlightArea(this.mapSavedAreaId);
    }
  } else {
    this.loadPreloadedIndicatorLayers();
  }
}

// Load a state var with indicator layers from a pre-built map for one-time use
export function setPreloadedIndicatorLayers(mapLayerUpdateObjects) {
    this.setState({preloadedIndicatorLayers: mapLayerUpdateObjects});
}

export function addHoverPopupToMapLayer(layerId, summaryLevelCode) {
    if(summaryLevelCode !== '050') {
        return;
    }
    
    this.map.on('mousemove', layerId, (e) => {
        // Change the cursor style as a UI indicator.
        this.map.getCanvas().style.cursor = 'pointer';
         
        // Single out the first found feature.
        var feature = e.features[0];
         
        // Query the counties layer visible in the map. Use the filter
        // param to only collect results that share the same county name.
        // Add features that share the same county ogc_fid to the highlighted layer.
        var ogc_fid = feature.properties.ogc_fid;
        
        //if(this.highlighted !== ogc_fid)
        //{
        //    this.map.setFilter('counties-highlighted', [
        //        '==',
        //        'ogc_fid',
        //        ogc_fid
        //    ], {'validate': false});
        //}
        this.highlighted = ogc_fid;
        // Display a popup with the name of the county
        //console.log(feature.properties);
        if(this.indicatorLabels[layerId] != null && this.indicatorLabels[layerId] !== 1 &&
           this.indicatorLabels[layerId][ogc_fid] != null)
        {
            var label1 = this.indicatorLabels[layerId][ogc_fid][0];
            var label2 = this.indicatorLabels[layerId][0][0]; // indicator description
            if(label2.endsWith('by County')) {
                label2 = label2.replace('by County', '');
            }
            var label3 = this.indicatorLabels[layerId][ogc_fid][1];
            var label4 = null;
            if(this.indicatorLabels[layerId][0].length > 3) {
                var label4 = this.indicatorLabels[layerId][0][3]; // indicator grand total
            }
            var label5 = null, label6 = null;
            if(this.indicatorLabels[layerId][ogc_fid].length > 3) {
                label5 = this.indicatorLabels[layerId][ogc_fid][2]; // state/aggregate name
                label6 = this.indicatorLabels[layerId][ogc_fid][3]; // state/aggregate total
            }
            var popupText = '<span class="mf-pop-title">' + label1 + '</span><span class="mf-pop-indicator"><small>' + label2 + '</small></span><span class="mf-pop-value">' + label3 + '</span>';
            if(label5 != null && label6 != null && label6 !== "No Data") {
                popupText += '<span class="mf-pop-state">' + label5 + ': ' + label6 + '</span>';
            }
            if(label4 != null && label4 !== "No Data") {
                popupText += '<span class="mf-pop-us">United States: ' + label4 + '</span>';
            }
            this.popup
            .setLngLat(e.lngLat)
            .setHTML(popupText)
            .addTo(this.map);
        }
    });
    
    this.map.on('click', layerId, (e) => {
        this.popup.remove();
        //console.log("click remove");
        // Change the cursor style as a UI indicator.
        //this.map.getCanvas().style.cursor = 'pointer';
         
        // Single out the first found feature.
        var feature = e.features[0];
                  
        // Add features that share the same county ogc_fid to the highlighted layer.
        var ogc_fid = feature.properties.ogc_fid;
        this.highlighted = ogc_fid;
        // Display a popup with the name of the county
        //console.log(feature.properties);
        if(this.indicatorLabels[layerId] != null && this.indicatorLabels[layerId] !== 1 &&
           this.indicatorLabels[layerId][ogc_fid] != null)
        {
            var label1 = this.indicatorLabels[layerId][ogc_fid][0];
            var label2 = this.indicatorLabels[layerId][0][0]; // indicator description
            if(label2.endsWith('by County')) {
                label2 = label2.replace('by County', '');
            }
            var label3 = this.indicatorLabels[layerId][ogc_fid][1];
            var label4 = null;
            if(this.indicatorLabels[layerId][0].length > 3) {
                var label4 = this.indicatorLabels[layerId][0][3]; // indicator grand total
            }
            var label5 = null, label6 = null;
            if(this.indicatorLabels[layerId][ogc_fid].length > 3) {
                label5 = this.indicatorLabels[layerId][ogc_fid][2]; // state/aggregate name
                label6 = this.indicatorLabels[layerId][ogc_fid][3]; // state/aggregate total
            }
            var popupText = '<span class="mf-pop-title">' + label1 + '</span><span class="mf-pop-indicator"><small>' + label2 + '</small></span><span class="mf-pop-value">' + label3 + '</span>';
            if(label5 != null && label6 != null && label6 !== "No Data") {
                popupText += '<span class="mf-pop-state">' + label5 + ': ' + label6 + '</span>';
            }
            if(label4 != null && label4 !== "No Data") {
                popupText += '<span class="mf-pop-us">United States: ' + label4 + '</span>';
            }
            this.popup = new mapboxgl.Popup();
            this.popup
            .setLngLat(e.lngLat)
            .setHTML(popupText)
            .addTo(this.map);
            //console.log("click popup");
        }
        
    });

    this.map.on('mouseleave', layerId, () => {
        //this.map.getCanvas().style.cursor = '';
        //console.log("mouseleave");
        this.popup.remove();
        //map.setFilter('counties-highlighted', ['in', 'COUNTY', '']);
        //overlay.style.display = 'none';
    });
}
// Do a one-time initialization of indicator layers from a pre-build map
export function loadPreloadedIndicatorLayers() {
    if(this.state.preloadedIndicatorLayers != null) {
        if(this.state.filterByArea === true && this.mapSavedAreaId == null) {
            // reset filterByArea if saved map has no selected area
            this.setState({filterByArea: false}, () => {
                for(var i = 0; i < this.state.preloadedIndicatorLayers.length; i++) {
                    this.updateMapLayer(this.state.preloadedIndicatorLayers[i], true);
                }
                this.setState({preloadedIndicatorLayers: null});
            });
        } else {
            for(var i = 0; i < this.state.preloadedIndicatorLayers.length; i++) {
                this.updateMapLayer(this.state.preloadedIndicatorLayers[i], true);
            }
            this.setState({preloadedIndicatorLayers: null}, () => {
                this.zoomMapAndHighlightArea(this.mapSavedAreaId, true);
            });
        }
    }

    // TODO: for a non-area-masked (all of US) dataset use a pre-compiled array of all shapes indexed to match an index property we set in the TIGER shape list
    if(this.state.filterByArea === true) {
        this.setFilterByArea(true);
    } else {
        this.setFilterByArea(false);
    }
}

/* update one ordered layer of the map with new data */
// TODO: check for total number of vector layers vs total props.indicators
const MAX_ALLOWED_MAP_LAYERS = 90;
export function updateMapLayer(item, refresh = false, placeLayerBefore = null, rebuildLayer = false) {
  if(!this.state.mapInitialized) {
    console.log("map not initialized, nothing to do");
    return;
  }
  //let currentLayers = this.map.getStyle().layers;
  //let currentLayersCount = currentLayers.length;
  let currentLayersCount = this.mapIndicatorLayers.length;
  // get the layer we've been told to update
  let updatedLayer = this.findLayerByIndicatorId(item.indicatorId);
  if(rebuildLayer === true || (updatedLayer == null &&
     currentLayersCount < MAX_ALLOWED_MAP_LAYERS)) {
    if(rebuildLayer !== true) {
        this.mapIndicatorLayers.push({
            "indicatorId": item.indicatorId,
            "layerId": item.indicatorId,
            "zIndex": 98 - currentLayersCount,
            "paletteIndex": item.paletteIndex,
            "customPalette": item.customPalette,
            "visible": item.visible});
        this.updateAreaHighlightVisibility();
    }
    // create any layer that doesn't yet exist
    // Z-Index of layers at top of our indicator list is highest
    // In Mapbox GL layers positioned "before" a layer are painted under it
    // So this.mapIndicatorLayers is reverse of Mapbox GL paint order
    if(placeLayerBefore == null) {
        if(currentLayersCount > 0) {
            placeLayerBefore = this.mapIndicatorLayers[currentLayersCount-1].layerId;
        } else {
            placeLayerBefore = this.firstSymbolId;
        }
    }
    //console.log("Adding layer", item);
    const bivariate = item.indicatorId.length === 2;
    this.map.addLayer({
        "id": bivariate ? item.indicatorId[0] + "," + item.indicatorId[1] : 
            item.indicatorId,
        "type": "fill",
        "source": "base"+item.summaryLevelCode+"vectortiles",
        "source-layer": "base"+item.summaryLevelCode,
        'layout': {
            'visibility': item.visible === true ? 'visible' : 'none',
        },
        'paint': {
            /* 'fill-outline-color': colors_def_transparent[1], */
            'fill-opacity': 1.0,
            'fill-color': 'transparent'
        },
    }, placeLayerBefore);

    updatedLayer = item.indicatorId;
    // force load of indicator data for new layer
    refresh = true;
    /*
    'fill-color': [
        'match',
        ['get', 'geo_id'],
        indicator_quartile_data[1], colors_def_transparent[1],
        indicator_quartile_data[2], colors_def_transparent[2],
        indicator_quartile_data[3], colors_def_transparent[3],
        indicator_quartile_data[4], colors_def_transparent[4],
        colors_def_transparent[6]
    ]
    */
  }
  if (updatedLayer == null) {
    return;
  }

  // force refresh of data for layer if requested
  if (refresh) {
      if(this.mapSavedAreaId == null || this.state.filterByArea !== true) {
        this.loadIndicatorData(item.indicatorId, this.mapSavedAreaId);
      } else {
        this.loadIndicatorDataForArea(item.indicatorId, this.mapSavedAreaId);
      }
      // TODO: Enable mouseover popups only for county-level data for now
      if(this.addHoverPopupToMapLayer !== undefined)
      {
        this.addHoverPopupToMapLayer(item.indicatorId, item.summaryLevelCode);
      }
  }
  if(item.opacity != null) {
      this.map.setPaintProperty(updatedLayer, 'fill-opacity', item.opacity);
  }
  let visibility = item.visible === true;
  // update layer visibility if it changed
  if((this.map.getLayoutProperty(updatedLayer, 'visibility') === 'visible') !== visibility) {
    this.handleMapLayerVisibilityChanged(item.indicatorId, visibility);
  } else {
    this.updateAreaHighlightVisibility();
  }
  // console.log('updateMapLayercalled')
}

/* https://stackoverflow.com/questions/14488849/higher-dpi-graphics-with-html5-canvas */
/*function setDPI(canvas, dpi) {
    // Set up CSS size.
//    canvas.style.width = canvas.style.width || canvas.width + 'px';
//    canvas.style.height = canvas.style.height || canvas.height + 'px';
    canvas.style.width = canvas.width + 'px';
    canvas.style.height = canvas.height + 'px';

    // Get size information.
    var scaleFactor = dpi / 96;
    var width = parseFloat(canvas.style.width);
    var height = parseFloat(canvas.style.height);

    // Backup the canvas contents.
    var oldScale = canvas.width / width;
    var backupScale = scaleFactor / oldScale;
    var backup = canvas.cloneNode(false);
    backup.getContext('2d').drawImage(canvas, 0, 0);

    // Resize the canvas.
    var ctx = canvas.getContext('2d');
    canvas.width = Math.ceil(width * scaleFactor);
    console.log("set canvas.width", width*scaleFactor, canvas.width);
    canvas.height = Math.ceil(height * scaleFactor);

    // Redraw the canvas image and scale future draws.
    ctx.setTransform(backupScale, 0, 0, backupScale, 0, 0);
    ctx.drawImage(backup, 0, 0);
    ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
}
*/
function setDPI(canvas, dpi) {
    // Set up CSS size.
    canvas.style.width = canvas.width + 'px';
    canvas.style.height = canvas.height + 'px';

    // Resize canvas and scale future draws.
    var scaleFactor = dpi / 96;
    canvas.width = Math.ceil(canvas.width * scaleFactor);
    canvas.height = Math.ceil(canvas.height * scaleFactor);
    var ctx = canvas.getContext('2d');
    //ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
    ctx.scale(scaleFactor, scaleFactor);
}



// WEBPACK FOOTER //
// ./src/modules/mapboxgl/mapFunctions.js